import { Sparkles } from "lucide-react";

export const Takeaways = ({ items, locked }) => {
  if (!items?.length) return null;
  return (
    <aside data-testid="ai-takeaways-container" className="bg-[#FFF6F5] border border-[#F7CFCB] p-6 sm:p-8 my-10">
      <div className="flex items-center gap-2 overline text-[#E5332A]"><Sparkles size={14} /> AI Key Takeaways</div>
      <ul className="mt-5 space-y-3">
        {items.map((t, i) => (
          <li key={i} className="flex gap-4 text-[15px] leading-relaxed" data-testid={`ai-takeaway-${i}`}>
            <span className="font-mono-d text-xs text-[#E5332A] pt-1">{String(i + 1).padStart(2, "0")}</span>
            <span>{t}</span>
          </li>
        ))}
      </ul>
      {locked && <p className="mt-5 text-xs text-[#575757] border-t border-[#F7CFCB] pt-4">More takeaways are available to subscribers.</p>}
      <p className="mt-4 text-[11px] text-[#575757]/70">Generated with AI and reviewed by the Africa Brew Brief editorial desk.</p>
    </aside>
  );
};
